export const PATH_NPS_FEEDBACK = '/api/v2/feedback';
